

















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { Notice, NoticeProps } from '@tencent/wphk-ui';
import { NoticeConfig  } from './type';
import { to } from '@tencent/wphk-base-utils';
import { getConfig } from './config';
import { CustomException, language } from '@tencent/ppd-base-libs';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { biClick } from '@tencent/fit-bi-sdk';

@Component({
  components: {
    Notice,
  },
})
export default class NoticeComponent extends Vue {
  /** 业务名称，需与配置中心配置的名称一致 */
  @Prop({ default: '' }) business!: string;
  /** 页面名称，需与配置中心配置英文名称一致 */
  @Prop({ default: '' }) page!: string;
  /** 若外部传入config，则使用外部config。 */
  @Prop({ default: null }) config?: NoticeConfig;
  /** 若外部未传入config，则根据 business/page 手动初始化config. 需设置为 null，否则会丢失响应式 */
  private innerConfig: NoticeConfig | null = null;
  /** 是否展示notice组件 */
  private show = true;

  /** 获取公告内容 */
  get content() {
    return this.finalConfig?.content[language.getLanguage()];
  }
  /** 获取左侧图标，只有喇叭图标或不显示 */
  get leftIconType(): NoticeProps['leftIconType'] {
    return this.finalConfig?.hasNoticeIcon ? 'notice' : '';
  }

  /** 获取右侧图标  */
  get rightIconType(): NoticeProps['rightIconType'] {
    // 若可以手动关闭，显示关闭图标
    if (this.finalConfig?.closeable) {
      return 'delete';
    }
    // 否则若有跳转链接，显示 arrow 图标，否则不显示图标。
    return this.finalConfig?.jumpUrl ? 'arrow' : '';
  }

  /** 获取公告主题 */
  get theme():  NoticeProps['theme'] {
    return this.finalConfig?.theme || 'warn';
  }

  /** 获取最终的config，可能是外部传入，也可能是内部获取的配置 */
  get finalConfig() {
    return this.config || this.innerConfig;
  }
  /** bi参数 */
  get biExt() {
    return {
      /** 业务 */
      fbusiness: this.finalConfig?.business || '',
      /** 页面 */
      fpage: this.finalConfig?.page || '',
    };
  }

  async mounted() {
    if (!this.config) {
      await this.getConfig();
    } else {
      this.innerConfig = this.config;
    }
  }

  async getConfig() {
    const [err, res] = await to(getConfig({
      business: this.business,
      page: this.page,
    }));
    if (err) {
      throw new CustomException(err, 'NoticeGetConfigError', `business: ${this.business} page: ${this.page}`);
    }
    if (res) {
      this.innerConfig = res;
    }
  }

  /** 点击公告本身 */
  @Emit('onClick')
  onClick() {
    if (this.finalConfig?.jumpUrl) {
      jumpPage.jumpUrl(this.finalConfig.jumpUrl, {
        adtag: this.business,
      });
    }
    biClick('wphk-components-notice.click|公告组件点击事件', this.biExt);
  }

  /** 点击右侧按钮 */
  @Emit('onRightIconClick')
  onRightIconClick() {
    // 若图标为x，则隐藏本组件
    if (this.rightIconType === 'delete') {
      this.show = false;
      biClick('wphk-components-notice.close|公告组件关闭事件', this.biExt);
      return;
    }
    // 否则，触发点击事件
    this.onClick();
  }
}
